import { Button, ButtonProps, chakra, Text, TextProps } from "@chakra-ui/react";
interface ICustonButtom extends ButtonProps {
  variant?: "primary" | "custom" | "label" | "light";
  width?: string;
  bg?: string;
  color?: string;
  padding?: string;
  fontWeight?: number;
  fontSize?: string;
  height?: string;
  borderRadius?: string;
  text?: string;
  startadornicon?: any;
  endadornicon?: any;
  onClick?: () => void | null;
  textProps?: TextProps;
}
export const CustonButtom = (props: ICustonButtom) => {
  const {
    variant = "primary",
    width = "auto",
    bg = variant === "primary"
      ? "transparent"
      : variant === "label"
      ? "theme.brown.100"
      : "transparent",
    color = variant === "primary"
      ? "#FFF"
      : variant === "label"
      ? "theme.gray.500"
      : variant === "light"
      ? "theme.text.primaryDark"
      : "theme.white",
    padding = "0px 16px",
    fontWeight = 700,
    fontSize = "16px",
    height = "39px",
    borderRadius = "4px",
    text = "",
    border = variant === "label" ? "1px solid" : 0,
    borderColor = variant === "label" ? "theme.brown.100" : "transparent",
    onClick = () => null,
    startadornicon = null,
    endadornicon = null,
    textProps = {},
  } = props;
  const StyledBtn = chakra(Button, {
    baseStyle: {
      height: height,
      width: width,
      backgroundColor: bg,
      color: color,
      padding: padding,
      borderRadius: borderRadius,
      fontWeight: fontWeight,
      fontSize: fontSize,
      border: border,
      borderColor: borderColor,
    },
  });
  return (
    <StyledBtn
      display={"flex"}
      alignItems={"center"}
      {...props}
      onClick={onClick}
    >
      {startadornicon}
      {text && text.length > 0 && <Text {...textProps}>{text}</Text>}
      {endadornicon}
    </StyledBtn>
  );
};

export const CustomOutLinedButton = ({ ...props }: ICustonButtom) => {
  return (
    <CustonButtom
      fontSize="14px"
      height="44px"
      border={"1px solid"}
      borderColor={"theme.button.primary"}
      padding="0px 12px"
      variant="custom"
      color={"purple.500"}
      {...props}
    />
  );
};
